import { store } from '@/store'
import { assetV2Api } from '@/store/services'
import { useEffect, useState } from 'react'
import { createSearchParams } from 'react-router-dom'
import { AsyncPaginate } from 'react-select-async-paginate'
import { SelectWrapper } from '../wrapper'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const AssetSelector = ({ value, onChange, valueField = 'identifier' }) => {
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState({})
  const loadOptions = async (search, _loadedOptions, { page }) => {
    const searchParams = createSearchParams({
      page,
      q: search,
      'order[field]': 'identifier_value',
      'order[sort]': 'asc'
    }).toString()

    const response = await store.dispatch(
      assetV2Api.endpoints.getAssetsV2.initiate(searchParams, { subscribe: true })
    ).unwrap()

    const options = (response.assets || []).map((asset) => {
      const identifier = asset.identifier_value || `asset-${asset.id}`
      return {
        value: valueField === 'id' ? asset.id : identifier,
        label: identifier,
        data: { attachableType: 'Asset', id: asset.id, identifier }
      }
    })
    const hasMore = page < (response.meta?.pagination?.total_pages || 1)

    return {
      options,
      hasMore,
      additional: {
        page: page + 1
      }
    }
  }

  // Si el selector esta en un popover o modal, se pierde el selectedOption
  // Esta es una forma para rescatarlo si es que se pierde el estado.
  useEffect(() => {
    if (!value) {
      setSelectedOption({})
      return
    }
    if (value === selectedOption.value) return

    setSelectedOption({
      value,
      label: value
    })
  }, [value])

  const handleChange = (option = {}) => {
    setSelectedOption(option)
    onChange(option)
  }

  return (
    <SelectWrapper label={t('asset_v2.one')}>
      {(styles) => (
        <AsyncPaginate
          loadingMessage={() => t('select.loading')}
          value={selectedOption?.value ? selectedOption : null}
          debounceTimeout={600}
          placeholder={t('select.one')}
          onChange={handleChange}
          loadOptions={loadOptions}
          styles={styles}
          menuPortalTarget={document.body}
          isClearable
          additional={{
            page: 1
          }}
        />
      )
      }
    </SelectWrapper>
  )
}

AssetSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueField: PropTypes.oneOf(['identifier', 'id'])
}
